import { useQuery, UseQueryResult } from 'react-query';
import { AthleteWrite } from 'types';
import { client } from 'utils/api-client';

function useSelfAthlete(): UseQueryResult<{ data: AthleteWrite }> {
  return useQuery(['athletes', 'self'], () => client.get(`athletes/self`));
}

export default useSelfAthlete;
